import 'normalize.css';

import '@fontsource/rubik/latin-700.css'; // bold
import '@fontsource/rubik/latin-500.css'; // medium
import '@fontsource/rubik/latin-400.css'; // regular
import '@fontsource/rubik/latin-300.css'; // light

import 'prismjs/themes/prism.css';
